// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../public/assets/images/common/currency-btc.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-wrapper .currency-btc-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: calc(100% - 8px);
  padding-right: 34px;
}

.currency-dropdown-wrap .non-cash-amount {
  color: var(--headingLink);
}
.currency-dropdown-wrap .dropdown-item.currency-img-header {
  padding: 0.56rem;
}
.currency-dropdown-wrap .dropdown-item.currency-img-header img {
  width: 1rem;
}
.currency-dropdown-wrap .dropdown-item .currency-unit {
  min-width: 50%;
  margin-right: 0.313rem;
}
.currency-dropdown-wrap .dropdown-item span {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.currency-dropdown-wrap .dropdown-item span img {
  margin-left: 0.313rem;
}

.main-currency-wrapper .currency-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
}
@media screen and (max-width: 425px) {
  .main-currency-wrapper .currency-text {
    font-size: 0.7rem;
  }
}

.currency-main img {
  width: 2.5rem;
  height: 2.5rem;
}
.currency-main .currency-text {
  min-width: 100px;
}

.currency-notification {
  color: var(--authSocailTextColor);
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/components/CurrencyDropdown/CurrencyDropdown.scss"],"names":[],"mappings":"AACE;EACE,mDAAA;EACA,4BAAA;EACA,qBAAA;EACA,qCAAA;EACA,mBAAA;AAAJ;;AAQE;EACE,yBAAA;AALJ;AASI;EACE,gBAAA;AAPN;AASM;EACE,WAAA;AAPR;AAWI;EACE,cAAA;EACA,sBAAA;AATN;AAYI;EAEE,mBAAA;EACA,aAAA;EACA,yBAAA;AAXN;AAaM;EACE,qBAAA;AAXR;;AAoBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE;IACE,iBAAA;EAlBJ;AACF;;AAuBE;EAEE,aAAA;EACA,cAAA;AArBJ;AAwBE;EACE,gBAAA;AAtBJ;;AA0BA;EACE,iCAAA;EACA,mBAAA;AAvBF","sourcesContent":[".currency-wrapper {\n  .currency-btc-icon {\n    background: url('../../../../../../public/assets/images/common/currency-btc.png');\n    background-repeat: no-repeat;\n    background-size: 16px;\n    background-position: calc(100% - 8px);\n    padding-right: 34px;\n  }\n}\n\n// .currencies-options{\n//   min-width: 200px;\n// }\n.currency-dropdown-wrap {\n  .non-cash-amount {\n    color: var(--headingLink);\n  }\n\n  .dropdown-item {\n    &.currency-img-header {\n      padding: 0.56rem;\n\n      img {\n        width: 1rem;\n      }\n    }\n\n    .currency-unit {\n      min-width: 50%;\n      margin-right: 0.313rem;\n    }\n\n    span {\n      // min-width: 50%;\n      align-items: center;\n      display: flex;\n      justify-content: flex-end;\n\n      & img {\n        margin-left: 0.313rem;\n      }\n    }\n  }\n}\n\n.main-currency-wrapper {\n\n  // gap: 0.75rem;\n  .currency-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n    font-weight: 600;\n  }\n\n  @media screen and (max-width: 425px) {\n    .currency-text {\n      font-size: 0.7rem;\n    }\n  }\n}\n\n.currency-main {\n  img {\n    // width:1rem;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .currency-text {\n    min-width: 100px;\n  }\n}\n\n.currency-notification {\n  color: var(--authSocailTextColor);\n  font-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
